import { createAction } from '@reduxjs/toolkit'

import { IAllocationKey } from 'types/GlobalAllocationKey'

// tryCreateAllocationKey
export const create = createAction('create_allocation_key')
export const createSuccess = createAction<{ data: IAllocationKey }>(
  'create_allocation_key_success'
)
export const createFailed = createAction('create_allocation_key_failed')

// tryUpdateAllocationKey
export const update = createAction('update_allocation_key')
export const updateSuccess = createAction<{ data: IAllocationKey }>(
  'update_allocation_key_success'
)
export const updateFailed = createAction('update_allocation_key_failed')

// tryGetAllAllocationKeys
export const getAll = createAction('get_all_allocation_keys')
export const getAllSuccess = createAction<{ data: IAllocationKey[] }>(
  'get_all_allocation_keys_success'
)
export const getAllFailed = createAction('get_all_allocation_keys_failed')

// tryDeleteAllocationKey
export const destroy = createAction('destroy_allocation_key')
export const destroySuccess = createAction<string>(
  'destroy_allocation_key_success'
)
export const destroyFailed = createAction('destroy_allocation_key_failed')
